import * as React from 'react'
import * as RadixDialog from '@radix-ui/react-dialog'







export const Dialog = (props) => {
  const {isOpen, onClose, children, ...other} = props
  return (
    React.createElement(RadixDialog.Root, {
      open: isOpen,
      onOpenChange: (newOpen) => {
        if (!newOpen) {
          onClose()
        }
      },
      ...other,}

      , children
    )
  )
}
